import angular from 'angular';
import swal from 'sweetalert';

class FormController {
    constructor(Model) {
        this.Model = Model;
        this.fields = this.getFields();
        this.model = this.model || {};
        this.clone = angular.copy(this.model);
        this.onSubmit = this.onSubmit || angular.noop;
        this.onCancel = this.onCancel || angular.noop;
    }

    submit() {
        this.Model.create(this.clone, {upsert: true}).then((data) => {
            swal("", "Podaci su uspiješno pohranjeni", "success");
            this.onSubmit({model: data});
        });
    }

    cancel() {
        if (this.form.$pristine) {
            this.onCancel();
            return;
        }
        swal({
            title: "Jeste li sigurni?",
            text: "Podaci nisu spremljeni. Želite li zatvoriti formu za unos?",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Da, zatvori!",
            cancelButtonText: 'Odustani',
            closeOnConfirm: true
        },
        () => this.onCancel());
    }

    getFields(){
        return {
            sifra: {
                key: 'sifra',
                type: 'hInput',
                templateOptions: {
                    label: 'Šifra'
                }
            },
            prezime: {
                key: 'prezime',
                type: 'hInput',
                templateOptions: {
                    label: 'Prezime'
                }
            },
            ime: {
                key: 'ime',
                type: 'hInput',
                templateOptions: {
                    label: 'Ime'
                }
            },
            jmbg_oib: {
                key: 'jmbg_oib',
                type: 'hInput',
                templateOptions: {
                    label: 'OIB'
                }
            },
            datum_rodjenja: {
                key: 'datum_rodjenja',
                type: 'hDatepicker',
                templateOptions: {
                    label: 'Datum rođenja'
                }
            },
            ulica_kbr: {
                key: 'ulica_kbr',
                type: 'hInput',
                templateOptions: {
                    label: 'Ulica i kbr.'
                }
            },
            grad: {
                key: 'grad',
                type: 'hInput',
                templateOptions: {
                    label: 'Grad'
                }
            },
            tel_mob: {
                key: 'tel_mob',
                type: 'hInput',
                templateOptions: {
                    label: 'Telefon/Mobitel'
                }
            },
            zanimanje: {
                key: 'zanimanje',
                type: 'hInput',
                templateOptions: {
                    label: 'Zanimanje'
                }
            },
            email: {
                key: 'email',
                type: 'hInput',
                templateOptions: {
                    label: 'E-mail'
                }
            }
        };

    }
}

FormController.$inject = ['Djelatnik'];

export default FormController;



// WEBPACK FOOTER //
// ./app/components/djelatnik/form/form.controller.js